export function setDocTitle(page = ''): void {
  document.title = `GoParrot | ${page}`;
}
